<template>
  <div id="wrap_menu" :class="{ open: mobile_menu }">
    <div class="menu_content">
      <div class="left_part">
        <router-link to="/">
        <div class="logo_wrap">
          <img class="logo" src="../assets/img/ltg_logo.svg">
        </div>
        </router-link>
        <div class="basket_wrap">
          <router-link to="/basket">
            <img class="basket_img" src="../assets/img/shopping.svg">
            <div class="basket_point" v-if="basketState"></div>
          </router-link>
        </div>
        <div class="mobile_menu_button" @click="toggleMenu()"></div>
      </div>
      <div class="middle_part">
        <div class="menu_elem menu_elem_first">
          <router-link to="/">
              ГЛАВНАЯ
          </router-link>
          </div>
        <div class="menu_elem menu_elem_second menu_disabled menu_drop" @mouseover="catalog_over(true)" @mouseout="catalog_over(false)" @click="catalog_toggle()">
          <router-link to="" ref="el">
            РЕГИСТРАТОРЫ
          </router-link>
          <transition name="fade">
            <div class="drop_down_wrap">
            <div class="drop_down_menu drop_down_catalog" v-if="drop_catalog" @mouseover="catalog_over(true)">
              <router-link :to="{path: '/catalog/' + mark.name}" v-for="mark in category" :key="mark.id">
                {{mark.name.toUpperCase()}}
              </router-link>
            </div>
            </div>
          </transition>
        </div>
        <div class="menu_elem menu_elem_third">
          <router-link to="/instruction">
            УСТАНОВКА
          </router-link>
        </div>
        <div class="menu_elem menu_elem_forth">
          <router-link to="/delivery">
            ДОСТАВКА
          </router-link>
          </div>
        <div class="menu_elem menu_elem_five mobile_view">
          <router-link to="/contacts/map">
            КОНТАКТЫ
          </router-link>
        </div>
        <div class="menu_elem menu_elem_five desktop_view" @mouseover="contacts_over(true)" @mouseout="contacts_over(false)">
          <router-link to="/contacts/map">
            КОНТАКТЫ
          </router-link>
          <transition name="fade">
          <div class="drop_down_wrap">
          <div class="drop_down_menu drop_down_contacts" v-if="drop_contacts" @mouseover="contacts_over(true)">
            <!-- <router-link to="/contacts/about">
              О НАС
            </router-link> -->
            <router-link to="/contacts/partners">
              ПАРТНЁРАМ
            </router-link>
          </div>
          </div>
          </transition>
        </div>
      </div>
      <div class="right_part">
        <table>
          <tr>
            <td>
              <div class="phone info">
                <img src="../assets/img/phonecall.svg"/>
                <p>+7 920 222 66 44</p>
              </div>
            </td>
            <td>
              <div class="worktime info">
                <img src="../assets/img/clock.svg"/>
                <p>10.00-20.00</p>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import host from './host.js';
export default {
  name: 'Menu',

  data () {
    return {
      drop_contacts: false,
      drop_catalog: false,
      category: null,
      mobile_menu: false,
    }
  },
  mounted () {
    this.$store.dispatch('checkBasket')
    this.$http.get(host + 'marks/').then(function(response) {
          this.category = response.data;
          console.log(response)
      }, function(error) {
          console.log(error)
          /* DEV */
          this.category = [{"id":6,"name":"Audi"},{"id":1,"name":"BMW"},{"id":3,"name":"Hyundai"},{"id":7,"name":"Infinity"},{"id":14,"name":"Jaguar"},{"id":4,"name":"Kia"},{"id":8,"name":"LandRover"},{"id":9,"name":"Nissan"},{"id":10,"name":"Porsche"},{"id":11,"name":"Subaru"},{"id":12,"name":"Toyota"},{"id":5,"name":"Volkswagen"},{"id":2,"name":"Volvo"}]
          /* /DEV */
      });
  },
  computed: {
    basketState(){
      return this.$store.state.basketState
    }
  },
  methods: {
    contacts_over(value) {
      this.drop_contacts = value
    },
    catalog_over(value) {
        if ( window.innerWidth <= 1024 ) return
        this.drop_catalog = value
        this.updateHover()
    },
    catalog_toggle(el) {
      if ( window.innerWidth > 1024 ) return
      this.drop_catalog = !this.drop_catalog
      this.updateHover()
    },
    toggleMenu() {
      this.mobile_menu = !this.mobile_menu
      this.updateBodyOverflow()
    },
    showMenu() {
      this.mobile_menu = true
      this.updateBodyOverflow()
    },
    hideMenu() {
      this.mobile_menu = false
      this.updateBodyOverflow()
    },
    updateBodyOverflow() {
      if ( this.mobile_menu ) {
        $('body').addClass( 'mobile_menu_open' )
      } else {
        $('body').removeClass( 'mobile_menu_open' )
      }
      this.drop_catalog = false
      this.updateHover()
    },
    updateHover() {
      ;( this.drop_catalog )
        ? $(this.$refs.el.$el).addClass('hover')
        : $(this.$refs.el.$el).removeClass('hover')
    }
  },
  watch:{
    $route (to, from){
        this.mobile_menu = false
        this.updateBodyOverflow()
    }
  }
}
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.menu_elem{
  float: left;
  padding-top: 16px;
  position: relative;
}
.menu_elem:nth-child(1){
  width: 17%;
}
.menu_elem:nth-child(1n+2){
  width: 19%;
}
.menu_elem:nth-child(2){
  width: 25%;
}
.menu_elem a{
  font-family: TextProMedium;
  font-size: 10pt;
}
.menu_elem::after{
  content: '';
  display: block;
  width: 0;
  height: 2px;
  background: #ce4c4c;
  margin:auto;
  // border-bottom: 3px solid#ce4c4c;
  transition: width .3s;
}
.menu_elem_first:hover::after{
  width: 60px;

}
.menu_elem_second:hover::after{
  width: 98px;

}
.menu_elem_third:hover::after{
  width: 75px;

}
.menu_elem_forth:hover::after{
  width: 68px;

}
.menu_elem_five:hover::after{
  width: 68px;
}

#wrap_menu {
    height: 5vh;
    min-height: 50px;
    width: 100vw;
    position: absolute;
    top: 5vh;
    left: 0;
    z-index: 9999;
}

.menu_content {
  height: 100%;
  width: 74vw;
  min-width: 1000px;
  margin: auto;
}

.left_part{
  float: left;
  height: 100%;
  width: 26%;
  min-width: 100px;
}
.right_part{
  float: left;
  height: 100%;
  width: 27%;
  min-width: 100px;
}
.middle_part{
  float: left;
  height: 100%;
  width: 47%;
  min-width: 200px;
}
.logo_wrap{
  float: left;
  width: 36%;
  min-width: 141px;
  height: 100%;
  cursor: pointer;
}
.logo {
  width: 100%;
  height: 100%;
}
.basket_wrap{
  float: left;
  width: 5%;
  min-width: 16px;
  height: 100%;
  margin-left: 12.5%;
  position: relative;
}
.basket_point{
  width: 8px;
  height: 8px;
  position: absolute;
  background-color: #ce4c4c;
  border-radius: 50%;
  top:13px;
  right: 3px;
}
.basket_img{
  width: 100%;
  height: auto;
  padding-top: 15px;
}
.menu_elem p{

}
.right_part table{
  float: right;
}
.info{
  float: right;
}
.info img {
  float: left;
  height: 12px;
  width: auto;
  padding-top: 15px;
  padding-right: 6px;
  vertical-align: middle;
}
.info p{
  float: left;
  margin-top:12px;
}
.worktime p{
  color: #cba35d;
  font-family: TextProBold;
  font-size: 12pt;
  margin-top: 12px;
}
.phone{
  margin-right: 15px;
}
.phone p{
  font-family: TextProLight;
  font-size: 12pt;
}
.drop_down_wrap{
  position: absolute;
  width: 100%;
  height: auto;
  text-align: left;
  top: 35px;
  left: 0;
  padding-top: 5px;
}
.drop_down_wrap a{
  width: 100%;
  float: left;
  margin-left: 12px;
  margin-right: 12px;
  font-family: TextProMedium;
  font-size: 10pt;
}
.drop_down_wrap a:hover{
  color: #cccccc;
}
.drop_down_menu{
  background-color: rgba($color: #070506, $alpha: .6);
  border-radius: 2px;
  position: absolute;
  height: auto;
  text-align: left;
  padding-top: 8px;
  padding-bottom: 5px;
}
.drop_down_catalog{
  width: 250%;
  left: -75%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(auto, 1fr);
}
.drop_down_catalog a{
  cursor: pointer !important;
}
.menu_disabled a{
  cursor: default;
}

.mobile_menu_button {
  display: none;
}

.mobile_view {
  display: none;
}

@media all and (max-width: 1024px) {
  #wrap_menu {
    padding: 0 5vh;
    height: 80px;
    left: 0;
    top: 0;
    box-sizing: border-box;
    text-align: left;
    position: fixed;
    background-color: #312f2f;
  }

  .menu_content {
    min-width: 0;
    width: auto;
    height: 80px;
  }

  .left_part {
    width: 100%;
    text-align: right;
    position: relative;
    z-index: 999;
    background-color: #312f2f;
    margin: -5vh;
    margin-top: 0;
    height: 40px;
    padding: 20px 5vh;

    & > a {
      display: inline-block;
      vertical-align: middle;
      width: 50%;
      height: 100%;
      float: left;
    }
  }

  .logo_wrap {
    width: auto;
    height: 32px;
    min-width: 0;
    float: none;
    text-align: left;
    padding: 4px 0;
  }

  .logo {
    width: auto;
    height: 32px;
  }

  .right_part {
    display: none;
  }

  .middle_part {
    position: fixed;
    right: -10vh;
    top: 0;
    padding: 15vh 5vh;
    background-color: #312f2f;
    width: 100%;
    box-sizing: border-box;
    float: none;
    min-width: 0;
    max-width: 0%;
    transition: right 0.5s ease, max-width 0.5s ease;
    overflow: hidden;
  }

    .open .middle_part {
      max-width: 100%;
      right: 0;
      overflow: auto;
      padding-bottom: 10vh;
    }

  .menu_elem {
    float: none;
    width: 100% !important;

    &.mobile_view {
      padding: 0;
      padding-top: 16px;
    }

    &:after {
      display: none;
    }

    a {
      font-size: 5vw;
      height: 1.5em;
      display: block;
    }
  }

  .basket_wrap {
    float: none;
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    width: auto;
    text-align: center;

    a {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      width: 40px;

      img {
        padding-top: 10px;
        height: 20px;
        width: auto;
      }
    }
  }

  .basket_point {
    top: 8px;
    left: 17px;
  }

  .mobile_menu_button {
    display: inline-block;
    vertical-align: middle;
    width: 40px;
    height: 40px;
    background-color: #cf3835;
    position: relative;
    margin-left: 20px;

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 13px;
      left: 11px;
      width: 17px;
      height: 2px;
      background-color: #cc9558;
      box-shadow: 0px 6px 0px #cc9558;
      transition: all 0.2s ease;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 13px;
      right: 12px;
      width: 11px;
      height: 2px;
      background-color: #cc9558;
      transition: all 0.2s ease;
    }
  }

  .open .mobile_menu_button {
    &:before {
      box-shadow: 0px 0px 0px #cc9558;
      transform: rotate(-45deg);
      top: 19px;
    }
    &:after {
      transform: rotate(45deg);
      width: 17px;
      bottom: 19px;
    }
  }

  .menu_drop {
    & > a {
      overflow-y: hidden;

      &:after {
        content: '';
        background: url(data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjkgMTI5Ij4NCiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyMS4zIDM0LjZjLTEuNi0xLjYtNC4yLTEuNi01LjggMGwtNTEgNTEuMS01MS4xLTUxLjFjLTEuNi0xLjYtNC4yLTEuNi01LjggMC0xLjYgMS42LTEuNiA0LjIgMCA1LjhsNTMuOSA1My45Yy44LjggMS44IDEuMiAyLjkgMS4yIDEgMCAyLjEtLjQgMi45LTEuMmw1My45LTUzLjljMS43LTEuNiAxLjctNC4yLjEtNS44eiIvPg0KPC9zdmc+) no-repeat center center transparent;
        display: inline-block;
        width: 0.5em;
        height: 0.5em;
        margin-left: 0.5em;
        border: none;
        transition: transform 0.2s ease;
      }

      &.hover:after {
        // width: 10px;
        transform: rotate(180deg);
      }
    }
  }

  .drop_down_wrap {
    position: static;
    padding-top: 0;
  }

  .drop_down_catalog {
    position: static;
    width: auto;
    display: block;
    left: 0;
    margin: 0 -5vh;
    padding: 5vh 0 5vh 15vw;
    column-count: 2;

    a {
      font-size: 4vw;
      position: static;
      float: none;
      display: block;
      margin-bottom: 1.5em;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Menu.vue